export const SUPPORTED_FILE_TYPES = [
  'image/png',
  'image/jpeg',
  'image/heic',
  'image/heif',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
  'text/csv',
  'application/csv',
  'video/mp4',
  'video/quicktime',
  'audio/mpeg',
  'message/rfc822',
  'application/vnd.ms-outlook',
  'application/octet-stream',
];

// File extensions to allow when browser MIME type detection is unreliable
export const SUPPORTED_FILE_EXTENSIONS = ['.msg'];
